<template>

  <svg
    t="1639130711621"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M948.55625 868.24999971H549.50000029V95.075L948.55625 868.24999971zM624.5 793.25h200.94374971L624.5 403.92500029V793.25zM474.49999971 95.075V868.24999971H75.44375L474.49999971 95.075z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconFlipH',
} as DefineComponent
</script>